export default __webpack_public_path__ + "static/coctail-03-f5ae930daf04d57be8e61c904b9f31be.png";